import { z } from "zod";

export const sellingPlanPriceAdjustmentSchema = z.object({
  value: z.number(),
  valueType: z.enum(["percentage", "fixedAmount", "price"]),
});

export const sellingPlanOptionValueSchema = z.object({
  name: z.string().optional(),
  value: z.string(),
});

export const sellingPlanSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  optionValues: z.array(sellingPlanOptionValueSchema),
  priceAdjustments: z.array(sellingPlanPriceAdjustmentSchema),
  appId: z.string().nullish(),
  price: z.string().optional(),
  externalId: z.string().nullable(),
});

export const sellingPlanGroupSchema = z
  .object({
    appId: z.string().nullable(),
    options: z.array(
      z.object({
        name: z.string(),
        values: z.array(z.union([z.string(), z.null()])),
      }),
    ),
    sellingPlans: z.array(sellingPlanSchema),
  })
  .describe("SellingPlanGroup");
